import { render } from "./WilcomEmbRenderStage.vue?vue&type=template&id=35d8ecb6&scoped=true"
import script from "./WilcomEmbRenderStage.vue?vue&type=script&lang=js"
export * from "./WilcomEmbRenderStage.vue?vue&type=script&lang=js"

import "./WilcomEmbRenderStage.vue?vue&type=style&index=0&id=35d8ecb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35d8ecb6"]])

export default __exports__